import styles from './ContactPage.module.scss';
import BackButton from '../../BackButton/BackButton';
import { Container } from '../../Container/Container';
import Map from './components/Map/Map';
import Brands from './components/Brands/Brands';
import { useGetShops } from '../../../queries/shops/useGetShops';
import { IMapProps } from './components/Map/Map';
import { generateImageUrl } from '../../../helpers/generateImageUrl';

const ContactPage = () => {
  const { shops, isGetShopsSuccess } = useGetShops();
  const shopsArr = shops
    ? shops.map((item) => {
        return {
          id: item.id,
          geometry: {
            coordinates: [item.gpsLongitude, item.gpsLatitude],
          },
          description: {
            name: item.name,
            address: item.address,
            tel: item.phoneNumber,
            workingHours: item.workingHours,
            city: item.city,
          },
        };
      })
    : [];
  return (
    <div className={styles.ContactPage}>
      <Container>
        <BackButton />
        <h1>Контакты</h1>
        <div className={styles.content_holder}>
          <div className={styles.text_holder}>
            <h2>Связь с технической поддержкой Groupe SEB</h2>
            <div className={styles.item}>
              <span>По вопросам работы сайта:</span>
              <a href="mailto:support@gsv-service.ru?subject=Вопрос по работе сайта GSV-Service">
                support@gsv-service.ru
              </a>
            </div>
            <div className={styles.item}>
              <span>Общие контакты:</span>
              <a href="mailto:support@gsv-service.ru?subject=Вопрос по работе сайта GSV-Service">
                support@gsv-service.ru
              </a>
            </div>
          </div>
          <div className={styles.image_holder}>
            <div className={styles.img}>
              <img
                src={generateImageUrl('seb_for_contacts_pic.png')}
                alt="contact image"
              />
            </div>
          </div>
        </div>
        <Brands />
        {isGetShopsSuccess && (
          <div className={styles.map_holder}>
            <h2>Сервисные центры</h2>
            <Map shops={shopsArr as IMapProps['shops']} />
          </div>
        )}
      </Container>
    </div>
  );
};

export default ContactPage;
